import React from "react";
import Button from "../../shared/button/Button";
import {
  EmailAddressList,
  EmailAddressListItem,
  EmailAddressValue,
  CenterButtonWrapper,
} from "../styles/share-modal-styles";

// disabling prop-types because this is a typescript component.
// declaring prop-types + ts interfaces is unneccesary duplication
/* eslint-disable react/prop-types */

export interface EmailsSentViewProps {
  showModalFn: (show: boolean) => void;
  emailAddresses: string[];
}

const EmailsSentView: React.FC<EmailsSentViewProps> = ({
  showModalFn,
  emailAddresses,
}) => (
  <>
    <EmailAddressList noMarginTop>
      {emailAddresses.map((emailAddress) => (
        <EmailAddressListItem key={emailAddress}>
          <EmailAddressValue>{emailAddress}</EmailAddressValue>
        </EmailAddressListItem>
      ))}
    </EmailAddressList>

    <CenterButtonWrapper>
      <Button
        primary
        type="button"
        buttonName="Close"
        onClickAction={() => showModalFn(false)}
      />
    </CenterButtonWrapper>
  </>
);

export default EmailsSentView;
